import 'reflect-metadata'
import {inject, injectable} from 'inversify'
import {TRangePickerContainerStore} from '@/components/containers/RangePickerContainer/TRangePickerContainerStore'
import {IFilterContainerStore, PaginationContainerStoreType} from '@/components/containers'

import {TSelectContainerStore} from '@/components'
import {
    DccFilterStoreSymbol,
    DccTableFilterCurrencySelectContainerStoreSymbol,
    DccTableFilterRangePickerContainerStoreSymbol,
    IDccTableFilterStore
} from '~/code/pages/DCC/components/DccTableFilter'
import {IDccTableStore} from '~/code/pages/DCC/components/DccTable/IDccTableStore'
import {makeObservable, observable, reaction, runInAction} from 'mobx'
import {DccTableFilterType} from '../models/DccTableFilterType'

@injectable()
export class DccTableFilterStore implements IDccTableFilterStore {
    filterStore: IFilterContainerStore
    rangePickerStore: TRangePickerContainerStore
    currencySelectStore: TSelectContainerStore
    dccTableStore: IDccTableStore
    filter: DccTableFilterType | null = null

    constructor(
        @inject(DccFilterStoreSymbol)
        filterStore: IFilterContainerStore,
        @inject(DccTableFilterRangePickerContainerStoreSymbol)
        rangePickerStore: TRangePickerContainerStore,
        @inject(DccTableFilterCurrencySelectContainerStoreSymbol)
        currencySelectStore: TSelectContainerStore
    ) {
        makeObservable(this, {
            filter: observable
        })
        this.filterStore = filterStore
        this.rangePickerStore = rangePickerStore
        this.currencySelectStore = currencySelectStore

        reaction(
            () => ({
                currency: this.currencySelectStore.value,
                startDate: this.rangePickerStore.startDate,
                endDate: this.rangePickerStore.endDate,
                filter: this.filterStore.submittedFilter
            }),
            () => this.setFilter()
        )

        this.setFilter()
    }

    private setFilter = () => {
        runInAction(
            () =>
                (this.filter = {
                    currency: this.currencySelectStore.value,
                    startDate: this.rangePickerStore.startDate,
                    endDate: this.rangePickerStore.endDate,
                    ...this.filterStore.getFilterForBackend()
                })
        )
    }

    refresh = () => {
        this.setFilter()
    }
}
